import { useCallback, useEffect, useState } from "react";
import {
  DrawerContent,
  DrawerFormBody,
  DrawerHeaderLabel,
  DrawerlabelContainer,
  DrawerWrapper,
  HorizondalLine,
  LoadMoreButton,
} from "./NotificationDrawerStyled";
import { BackButton } from "../../pages/MatterDetails/MatterDetailsStyled";
import {  ArrowRight, X } from "@phosphor-icons/react";
import { useDispatch, useSelector } from "react-redux";
import PropTypes from "prop-types";
import ErrorToast from "../Notification/ErrorToast";
import { Typography, Drawer } from "antd";
import groupNotificationsByDate from "../../utils/groupNotificationsByDate";
import { fetchNotifications, updateNotificationStatus } from "../../slice/Matterslice";
import { postHighlightedMatter } from "../../slice/MatterDetailsSlice";
import NotificationBlock from "../Notification/NotificationBlock";
import { useNavigate } from "react-router-dom";
import { onNotificationClickFactory } from "../../utils/navigationUrl";

const NotificationDrawer = ({ open, setOpen }) => {
  const dispatch = useDispatch();
  const navigate = useNavigate()
  const [showNotification, setShowNotification] = useState(false);
  const [grouped, setGrouped] = useState([]);
  const [notificationError, setNotificationError] = useState([]);
  const { unreadCount } = useSelector((state) => state.matter.notifications);
  const notificationRefreshTrigger = useSelector((state) => state.websocket.notificationRefreshTrigger);

  const fetchAllNotification = useCallback(
    (page = 1) => {
      dispatch(fetchNotifications({ offset: (page - 1) * 8 }))
        .unwrap()
        .then((response) => {
          if (response.status === 200) {
            const notificationList = response?.data?.results || [];
            setGrouped(groupNotificationsByDate(notificationList));
          }
        })
        .catch(() => {
          const id = Date.now().toString();
          const newMsg = "Error fetching notifications";
          setNotificationError([{ id, newMsg }]);
          setShowNotification(true);
        });
    },
    [dispatch]
  );

    // Initial fetch
  useEffect(() => {
    fetchAllNotification(1);
    if (open) {
      sessionStorage.removeItem("lastOpenedDoc");
    }
    if (!open &&  document.querySelector(".ant-drawer-body")) {
      document.querySelector(".ant-drawer-body").scrollTop=0
    }
  }, [open, fetchAllNotification]);

  // Refresh notifications when notification_update websocket message is received
  useEffect(() => {
    if (open && notificationRefreshTrigger > 0) {
      fetchAllNotification(1);
    }
  }, [notificationRefreshTrigger, open, fetchAllNotification]);

  const onClose = () => {
    setOpen(false);
  };

  const onNotificationClick = onNotificationClickFactory({
    dispatch,
    navigate,
    updateNotificationStatus,
    postHighlightedMatter,
    setNotificationError,
    setShowNotification,
    onClose,
    withRefresh: true,
  });

  return (
    <DrawerWrapper>
      <Drawer
        placement="left"
        closable={false}
        onClose={onClose}
        open={open}
        key="left"
        style={{
          left: "20px !important",
          top: "50px !important",
        }}
        autoFocus={true}
      >
        <DrawerContent>
          <DrawerlabelContainer>
            <DrawerHeaderLabel >{`Notifications (${unreadCount})`}</DrawerHeaderLabel>
            <BackButton>
              <X size={20} onClick={onClose} />
            </BackButton>
          </DrawerlabelContainer>
          <HorizondalLine />
          <DrawerFormBody>
            {Object.entries(grouped).map(([group, items]) => (
              <div key={group} style={{ marginBottom: 24 }}>
                <Typography.Text
                  style={{
                    color: "#5A6C87",
                    fontWeight: "600",
                    fontSize: "13px",
                    fontFamily: "Manrope"
                  }}
                >
                  {group}
                </Typography.Text>

                {items.map((item, index) => (
                  <NotificationBlock
                    key={item.id}
                    item={item}
                    index={index}
                    isLast={index === items.length - 1}
                    onClick={onNotificationClick}
                  />
              ))}
              </div>
            ))}
            <div>
                <LoadMoreButton
                  type="link"
                  onClick={() => {
                    onClose();
                    navigate('/notifications');
                  }}
                  style={{ padding: 0 }}
                >
                  View more <ArrowRight size={16} weight="thin" />
                </LoadMoreButton>
              
            </div>
          </DrawerFormBody>
        </DrawerContent>
      </Drawer>

      {showNotification && (
        <ErrorToast
          message={notificationError}
          onClose={(id) =>
            setNotificationError((prev) => prev.filter((msg) => msg.id !== id))
          }
        />
      )}
    </DrawerWrapper>
  );
};

NotificationDrawer.propTypes = {
  open: PropTypes.bool.isRequired,
  setOpen: PropTypes.func.isRequired
};

export default NotificationDrawer;
